import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/bot_express_logo.png'


const _hoisted_1 = { class: "min-h-screen bg-zinc-900 flex items-center justify-center p-1 sm:p-4 font-nunito" }
const _hoisted_2 = { class: "w-full max-w-lg" }
const _hoisted_3 = { class: "bg-white/5 rounded-xl overflow-hidden" }
const _hoisted_4 = { class: "p-6 sm:p-8" }
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "mt-8 text-center" }
const _hoisted_9 = { class: "text-[#888888] text-sm" }

import { toast, Toaster } from '@/components/ui/toast'
import { useAuth } from '@/composables/useAuth'
import { Loader2 } from 'lucide-vue-next'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

// Estado do formulário

export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordRecoveryView',
  setup(__props) {

const router = useRouter()
const { sendResetPasswordLink } = useAuth()
const email = ref('')
const isLoading = ref(false)

// Função de login
const handleSendPasswordResetLink = async () => {
  isLoading.value = true
  try {
    await sendResetPasswordLink(email.value)

    toast({
      title: 'Email enviado',
      description: 'Verifique seu email para redefinir a senha',
      class: 'bg-green-500 text-white',
      duration: 3000
    })

    email.value = ''
  } catch (error) {
    email.value = ''
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex items-center justify-center mb-8" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Logo",
            class: "h-auto w-[180px] sm:w-[280px]"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mb-8" }, [
              _createElementVNode("h2", { class: "text-white text-2xl font-bold mb-2" }, "Recuperar Senha"),
              _createElementVNode("p", { class: "text-[#888888]" }, "Digite seu email para enviarmos o link de redefinição de senha")
            ], -1)),
            _createElementVNode("form", {
              onSubmit: _withModifiers(handleSendPasswordResetLink, ["prevent"]),
              class: "space-y-5"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _cache[2] || (_cache[2] = _createElementVNode("label", {
                  for: "email",
                  class: "block text-sm font-medium text-[#AAAAAA]"
                }, "Email", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                    type: "email",
                    required: "",
                    class: "w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-[#555555] focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200",
                    placeholder: "seu@email.com"
                  }, null, 512), [
                    [_vModelText, email.value]
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" }, [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "18",
                      height: "18",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      class: "text-[#555555]"
                    }, [
                      _createElementVNode("rect", {
                        width: "20",
                        height: "16",
                        x: "2",
                        y: "4",
                        rx: "2"
                      }),
                      _createElementVNode("path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" })
                    ])
                  ], -1))
                ])
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: _normalizeClass(["w-full py-3 px-4 bg-[#10B981] hover:bg-[#0EA271] text-white font-medium rounded-md transition-colors duration-200 flex items-center justify-center", {
                'opacity-50 cursor-not-allowed pointer-events-none': !email.value || isLoading.value
              }]),
                disabled: !email.value || isLoading.value
              }, [
                (isLoading.value)
                  ? (_openBlock(), _createBlock(_unref(Loader2), {
                      key: 0,
                      class: "w-4 h-4 animate-spin mr-2"
                    }))
                  : _createCommentVNode("", true),
                _cache[3] || (_cache[3] = _createElementVNode("span", null, "Enviar", -1))
              ], 10, _hoisted_7)
            ], 32),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, [
                _cache[5] || (_cache[5] = _createTextVNode(" Lembrou sua senha? ")),
                _createVNode(_component_RouterLink, {
                  to: "/login",
                  class: "text-[#10B981] hover:text-[#0EA271] font-medium ml-1 transition-colors"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" Voltar ao login ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_unref(Toaster))
  ], 64))
}
}

})